export default __webpack_public_path__ + "locales/sq-AL/Settings.json?hash=13b56e22a123a28240dd687819b243ca";